import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, createVNode as _createVNode, resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, vShow as _vShow, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-3170ec8e"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["hidden"]
const _hoisted_2 = { class: "grid" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "field lg:col-2 md:col-2" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "day title-specified h-full flex align-items-center lg:justify-content-center al" }, "日時指定:")
], -1))
const _hoisted_4 = { class: "lg:col-10 md:col-10 cspicified-date m-0 p-0" }
const _hoisted_5 = { class: "field lg:col-8 md:col-8 mx-1 m-0 p-0 flex align-items-center" }
const _hoisted_6 = { class: "col" }
const _hoisted_7 = { class: "h-full flex lg:justify-content-center pt-1" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "monday_afternoon_end" }, "休業日", -1))
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "pi pi-times-circle delete-icon" }, null, -1))
const _hoisted_10 = [
  _hoisted_9
]
const _hoisted_11 = { class: "lg:col-12 md:col-10 cspicified-date align-items-center m-0 p-0" }
const _hoisted_12 = { class: "grid align-items-center" }
const _hoisted_13 = { class: "col" }
const _hoisted_14 = { class: "flex align-items-center" }
const _hoisted_15 = { class: "my-2 lg:col-4 md:col-12 flex align-items-center justify-content-start field" }
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "px-2" }, ":", -1))
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "time" }, "から", -1))
const _hoisted_18 = { class: "my-2 lg:col-4 md:col-12 flex align-items-center justify-content-start" }
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "px-2" }, ":", -1))
const _hoisted_20 = { class: "flex align-items-center" }
const _hoisted_21 = { class: "my-2 lg:col-4 md:col-12 flex align-items-center justify-content-start field" }
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "px-2" }, ":", -1))
const _hoisted_23 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "time" }, "から", -1))
const _hoisted_24 = { class: "my-2 lg:col-4 md:col-12 flex align-items-center justify-content-start" }
const _hoisted_25 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "px-2" }, ":", -1))

import { withDefaults, reactive, computed, ref, watch } from "vue";
import { get, MaybeRefOrGetter, set } from "@vueuse/core";
import { range } from "lodash";
import Calendar from "primevue/calendar";
import commonTimeWorkRules from "@/clinic/validates/validate.time-work";
import { Rule, Rules, ValidateError } from "async-validator";
import { notityErrorMsg } from "@/clinic/utils/notify-utils";
import { useAsyncValidator } from "@vueuse/integrations/useAsyncValidator";
import { useToast } from "primevue/usetoast";
import moment from "moment";

type IFieldValidator = {
  [key: string]: string;
};

type IFormRuleValidation = {
  startTimeMorning: number;
  endTimeMorning: number;
  startTimeAfterNoon: number;
  endTimeAfterNoon: number;
};

type IForm = {
  index: number;
  data: any;
  disabledDates?: Date[];
  showOtherMonths: boolean;
  selectOtherMonths: boolean;
  minDate?: Date;
};

export default /*#__PURE__*/_defineComponent({
  __name: 'special-date',
  props: {
    index: null,
    data: null,
    disabledDates: null,
    showOtherMonths: { type: Boolean },
    selectOtherMonths: { type: Boolean },
    minDate: null
  },
  emits: ["onDeleteDate", "validateFn", "updateDisabledDates"],
  setup(__props: any, { expose, emit: emits }) {

const props = __props as { index: number, data: any, disabledDates?: Date[], showOtherMonths: boolean, selectOtherMonths: boolean, minDate?: Date };

const dateWrapper = ref();


const initValidation = (value: IFieldValidator | any, rules: MaybeRefOrGetter<Record<string, Rule | Rules>>) =>
  useAsyncValidator(value, rules, { validateOption: { suppressWarning: true } });

const toast = useToast();

const tempDate = ref();
const changeDate = (dateValue: any) => {
  let dates = Object.assign([], props.disabledDates);
  if (dates?.length > 0) {
    const previousDate = tempDate.value || props.data.date;
    dates = dates.filter(date => moment(date).format("YYYY-MM-DD") !== moment(previousDate).format("YYYY-MM-DD"));
    dates.push(dateValue);
    emits("updateDisabledDates", dates);
  }
  const dateFormat = moment(dateValue).format("YYYY-MM-DD");
  set(form, "date", dateFormat);
  set(tempDate, dateValue);
};

const validate = async (fieldName?: string) => {
  const fieldTime = {
    startTimeMorning: parseInt(get(form.morning_shift_start)),
    endTimeMorning: parseInt(get(form.morning_shift_end)),
    startTimeAfterNoon: parseInt(get(form.afternoon_shift_start)),
    endTimeAfterNoon: parseInt(get(form.afternoon_shift_end)),
  } as IFormRuleValidation;

  const formRules = commonTimeWorkRules(fieldTime);
  const { pass: formPass } = initValidation(form, formRules);
  const [value, rules] = fieldName
    ? [{ [fieldName]: fieldTime[fieldName] }, { [fieldName]: formRules[fieldName] }]
    : [fieldTime, formRules];
  const { execute } = initValidation(value, rules);
  const { errorFields: fErrorFields, errors: fErrors } = await execute();
  set(errorFields, get(fErrorFields));
  set(pass, get(formPass));
  set(errors, get(fErrors));
  const fieldNames = Object.keys(fieldTime);
  fieldNames.forEach(fieldName => {
    if (errorFields.value[fieldName]) {
      const errorMessage = (errorFields.value[fieldName][0] as ValidateError).message;
      if (errorMessage) {
        notityErrorMsg(toast, errorMessage);
      }
    }
  });
  return get(pass);
};

const pass = ref(false);
const errorFields = ref<Record<string, ValidateError[]>>({});
const errors = ref<ValidateError[]>([]);

const deleteDate = (data: any) => emits("onDeleteDate", props.index);



const hours = [...Array(24).keys()].map(hour => {
  return {
    name: hour + "時",
    value: hour.toString(),
  };
});

const minutes = [...range(0, 60, 5)].map(minute => {
  return {
    name: minute + "分",
    value: minute.toString(),
  };
});

const formDataInit = computed(() => {
  const afternoon_shift_start = props.data.afternoon_shift_start.split(":")[0];
  const afternoon_shift_start_minutes = props.data.afternoon_shift_start.split(":")[1]
    ? props.data.afternoon_shift_start.split(":")[1]
    : "0";
  const morning_shift_start_minutes = props.data.morning_shift_start.split(":")[1]
    ? props.data.morning_shift_start.split(":")[1]
    : "0";
  const afternoon_shift_end = props.data.afternoon_shift_end.split(":")[0];
  const afternoon_shift_end_minutes = props.data.afternoon_shift_end.split(":")[1]
    ? props.data.afternoon_shift_end.split(":")[1]
    : "0";
  const morning_shift_start = props.data.morning_shift_start.split(":")[0];
  const morning_shift_end = props.data.morning_shift_end.split(":")[0];
  const morning_shift_end_minutes = props.data.morning_shift_end.split(":")[1]
    ? props.data.morning_shift_end.split(":")[1]
    : "0";
  const day_off = props.data.day_off;

  return {
    afternoon_shift_start: afternoon_shift_start,
    afternoon_shift_start_minutes: afternoon_shift_start_minutes,
    morning_shift_start_minutes: morning_shift_start_minutes,
    afternoon_shift_end: afternoon_shift_end,
    afternoon_shift_end_minutes: afternoon_shift_end_minutes,
    morning_shift_start: morning_shift_start,
    morning_shift_end: morning_shift_end,
    morning_shift_end_minutes: morning_shift_end_minutes,
    date: new Date(props.data.date),
    id: props.data.id,
    clinic_id: props.data.clinic_id,
    _destroy: false,
    day_off: day_off,
  };
});

const form = reactive(formDataInit.value);

const watchField = async (fieldName: string) => {
  watch(
    () => form[`${fieldName}`],
    async (newVal, oldVal) => {
      if (form.day_off) {
        set(pass, true);
      }
      const checkValidate = await validate(fieldName);
      if (!checkValidate) {
        set(form, fieldName as keyof typeof form, oldVal);
      }
      emits("validateFn", get(pass));
    }
  );
};

watchField("day_off");
watchField("morning_shift_start");
watchField("morning_shift_start_minutes");
watchField("morning_shift_end");
watchField("morning_shift_end_minutes");
watchField("afternoon_shift_start");
watchField("afternoon_shift_start_minutes");
watchField("afternoon_shift_end");
watchField("afternoon_shift_end_minutes");

const minDate = ref(moment(form.date.toString()).startOf("month").toDate());
const maxDate = ref(moment(form.date.toString()).endOf("month").toDate());

const getSpecialDateData = () => {
  return get(form);
};

const destroyDate = () => {
  set(form, "_destroy", true);
  get(dateWrapper).classList.add("hidden");
};

// eslint-disable-next-line no-undef
expose({
  getSpecialDateData,
  destroyDate,
});

return (_ctx: any,_cache: any) => {
  const _component_Checkbox = _resolveComponent("Checkbox")!
  const _component_Dropdown = _resolveComponent("Dropdown")!

  return (_openBlock(), _createElementBlock("div", {
    id: "clinic-special-date",
    class: "clinic-special-date pt-4",
    hidden: props.data?._destroy,
    ref_key: "dateWrapper",
    ref: dateWrapper
  }, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("div", _hoisted_5, [
          _createVNode(_unref(Calendar), {
            modelValue: form.date,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((form.date) = $event)),
            class: "justify-content-end h-48 w-7 ml-1",
            showIcon: "",
            dateFormat: "yy/mm/dd",
            showOtherMonths: props.showOtherMonths || false,
            selectOtherMonths: props.selectOtherMonths || false,
            onDateSelect: _cache[1] || (_cache[1] = ($event: any) => (changeDate($event))),
            minDate: props.minDate || minDate.value,
            maxDate: props.selectOtherMonths ? undefined : maxDate.value,
            disabledDates: props.disabledDates
          }, null, 8, ["modelValue", "showOtherMonths", "selectOtherMonths", "minDate", "maxDate", "disabledDates"]),
          _createElementVNode("div", _hoisted_6, [
            _createElementVNode("div", _hoisted_7, [
              _createVNode(_component_Checkbox, {
                modelValue: form.day_off,
                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((form.day_off) = $event)),
                inputId: "monday_afternoon_end",
                id: "monday_afternoon_end",
                name: "monday_afternoon_end",
                class: "mr-2 checkbox",
                value: true,
                binary: true
              }, null, 8, ["modelValue"]),
              _hoisted_8
            ])
          ]),
          _createElementVNode("p", {
            onClick: _cache[3] || (_cache[3] = ($event: any) => (deleteDate(props.index))),
            class: "cursor-pointer"
          }, _hoisted_10)
        ]),
        _withDirectives(_createElementVNode("div", _hoisted_11, [
          _createElementVNode("div", _hoisted_12, [
            _createElementVNode("div", _hoisted_13, [
              _createElementVNode("div", _hoisted_14, [
                _createElementVNode("div", _hoisted_15, [
                  _createVNode(_component_Dropdown, {
                    modelValue: form.morning_shift_start,
                    "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((form.morning_shift_start) = $event)),
                    options: _unref(hours),
                    optionLabel: "name",
                    optionValue: "value",
                    placeholder: "",
                    class: _normalizeClass(["shadow-none", { 'p-invalid': errorFields.value?.startTimeMorning }]),
                    onChange: _cache[5] || (_cache[5] = ($event: any) => (validate('startTimeMorning')))
                  }, null, 8, ["modelValue", "options", "class"]),
                  _hoisted_16,
                  _createVNode(_component_Dropdown, {
                    modelValue: form.morning_shift_start_minutes,
                    "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((form.morning_shift_start_minutes) = $event)),
                    options: _unref(minutes),
                    optionLabel: "name",
                    optionValue: "value",
                    placeholder: "",
                    class: _normalizeClass(["shadow-none", { 'p-invalid': errorFields.value?.startTimeMorning }])
                  }, null, 8, ["modelValue", "options", "class"])
                ]),
                _hoisted_17,
                _createElementVNode("div", _hoisted_18, [
                  _createVNode(_component_Dropdown, {
                    modelValue: form.morning_shift_end,
                    "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((form.morning_shift_end) = $event)),
                    options: _unref(hours),
                    optionLabel: "name",
                    optionValue: "value",
                    placeholder: "",
                    class: "shadow-none",
                    onChange: _cache[8] || (_cache[8] = ($event: any) => (validate('endTimeMorning')))
                  }, null, 8, ["modelValue", "options"]),
                  _hoisted_19,
                  _createVNode(_component_Dropdown, {
                    modelValue: form.morning_shift_end_minutes,
                    "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((form.morning_shift_end_minutes) = $event)),
                    options: _unref(minutes),
                    optionLabel: "name",
                    optionValue: "value",
                    placeholder: "",
                    class: "shadow-none"
                  }, null, 8, ["modelValue", "options"])
                ])
              ]),
              _createElementVNode("div", _hoisted_20, [
                _createElementVNode("div", _hoisted_21, [
                  _createVNode(_component_Dropdown, {
                    modelValue: form.afternoon_shift_start,
                    "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((form.afternoon_shift_start) = $event)),
                    options: _unref(hours),
                    optionLabel: "name",
                    optionValue: "value",
                    placeholder: "",
                    class: "shadow-none",
                    onChange: _cache[11] || (_cache[11] = ($event: any) => (validate('startTimeAfterNoon')))
                  }, null, 8, ["modelValue", "options"]),
                  _hoisted_22,
                  _createVNode(_component_Dropdown, {
                    modelValue: form.afternoon_shift_start_minutes,
                    "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((form.afternoon_shift_start_minutes) = $event)),
                    options: _unref(minutes),
                    optionLabel: "name",
                    optionValue: "value",
                    placeholder: "",
                    class: "shadow-none"
                  }, null, 8, ["modelValue", "options"])
                ]),
                _hoisted_23,
                _createElementVNode("div", _hoisted_24, [
                  _createVNode(_component_Dropdown, {
                    modelValue: form.afternoon_shift_end,
                    "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((form.afternoon_shift_end) = $event)),
                    options: _unref(hours),
                    optionLabel: "name",
                    optionValue: "value",
                    placeholder: "",
                    class: "shadow-none",
                    onChange: _cache[14] || (_cache[14] = ($event: any) => (validate('endTimeAfterNoon')))
                  }, null, 8, ["modelValue", "options"]),
                  _hoisted_25,
                  _createVNode(_component_Dropdown, {
                    modelValue: form.afternoon_shift_end_minutes,
                    "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => ((form.afternoon_shift_end_minutes) = $event)),
                    options: _unref(minutes),
                    optionLabel: "name",
                    optionValue: "value",
                    placeholder: "",
                    class: "shadow-none"
                  }, null, 8, ["modelValue", "options"])
                ])
              ])
            ])
          ])
        ], 512), [
          [_vShow, !form.day_off]
        ])
      ])
    ])
  ], 8, _hoisted_1))
}
}

})